import { useRef } from 'react';
import { IconButton, Tooltip, Typography } from '@mui/material';
import UploadIcon from '@mui/icons-material/Upload';

const FileUploadCell = ({ handleFileChange }) => {
    const inputRef = useRef(null);

    return (
        <>
            <Tooltip title="Subir comprobante">
                <IconButton
                    color="text"
                    size="small"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: 0,
                    }}
                    onClick={() => inputRef.current.click()}
                >
                    <UploadIcon fontSize="small" />
                    <Typography
                        sx={{
                            textAlign: 'center',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            maxWidth: 100,
                            lineHeight: 1.1,
                        }}
                    >
                        Subir comprobante
                    </Typography>
                </IconButton>
            </Tooltip>
            <input
                type="file"
                accept="image/*"
                ref={inputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />
        </>
    );
};

export default FileUploadCell;
